import { useState } from "react"
import { IoClose } from "react-icons/io5"
import { Button } from "@mylaunch/components/ui"
import { useInstallBannerState, usePWAInstallPrompt } from "../hooks"
import { isTelegramInAppBrowser } from "../lib/is-telegram-in-app-browser"
import { IOSInstallSheet } from "./ios-install-sheet"
import { TelegramOpenInBrowserBanner } from "./telegram-open-in-browser-banner"

export function PWAInstallPrompt() {
  const { canInstall, isIOS, prompt } = usePWAInstallPrompt()
  const { hidden, dismiss, markInstalled } = useInstallBannerState()
  const [sheetOpen, setSheetOpen] = useState(false)

  if (isTelegramInAppBrowser()) return <TelegramOpenInBrowserBanner />
  if (!canInstall || hidden) return null

  const handleInstall = async () => {
    if (isIOS) return setSheetOpen(true)
    const result = await prompt()
    if (result?.outcome === "accepted") markInstalled()
  }

  return (
    <>
      <div className="flex items-center gap-s px-m py-s bg-primary/10">
        <img src="/icon-192x192.png" alt="" className="size-8 rounded-md" />
        <div className="flex-1 text-sm leading-tight">
          <div>Установите GWService</div>
          <div className="text-muted-foreground">push-уведомления и быстрый вход</div>
        </div>
        <Button size="sm" className="rounded-full" onClick={handleInstall}>Установить</Button>
        <Button variant="ghost" size="icon" aria-label="Закрыть" onClick={dismiss}>
          <IoClose />
        </Button>
      </div>
      <IOSInstallSheet open={sheetOpen} onClose={() => setSheetOpen(false)} />
    </>
  )
}
